__turbopack_context__.v({
  "confirm": "ask-annonce-infos-module__hw-e5q__confirm",
  "open": "ask-annonce-infos-module__hw-e5q__open",
  "wrapper": "ask-annonce-infos-module__hw-e5q__wrapper",
});
